import React, { FC, memo } from 'react';
import { Outlet } from 'react-router-dom';
import { RequestFormModal } from 'widgets/RequestModal';
import { LogInModal } from 'widgets/LogInModal';
import { useInitializeApp } from 'app/appState';
import { PageLoader } from 'features/PageLoader';
import { GlobalConfirmModal } from 'app/globalConfirmModal';
import { SpecialPromotionModal } from 'features/SpecialPromotion';
import { CookieConsent } from 'features/CookieConsent';

export const GlobalLayout: FC = memo(() => {
  useInitializeApp();

  return (
    <PageLoader>
      <RequestFormModal />
      <LogInModal />
      <GlobalConfirmModal />
      <SpecialPromotionModal />
      <Outlet />
      <CookieConsent />
    </PageLoader>
  );
});
